export const FETCH_LIBRARY = "FETCH_LIBRARY";
export const FETCH_DECK = "FETCH_DECK";
export const FETCH_IMAGE = "FETCH_IMAGE";
export const UPDATE_ATTEMPT = "UPDATE_ATTEMPT";
export const COMPLETE_ATTEMPT = "COMPLETE_ATTEMPT";
export const INCOMPLETE_ATTEMPT = "INCOMPLETE_ATTEMPT";
export const AGGREGATE_TOPICS = "AGGREGATE_TOPICS";
export const AGGREGATE_COURSES = "AGGREGATE_COURSES";
export const AGGREGATE_PROGRAM = "AGGREGATE_PROGRAM";
export const RESET_DECK_ATTEMPT = "RESET_DECK_ATTEMPT";
export const FETCH_DECK_OFFLINE = "FETCH_DECK_OFFLINE";
export const FETCH_ASSESSMENT_OFFLINE = "FETCH_ASSESSMENT_OFFLINE";
export const FETCH_AUDIO = "FETCH_AUDIO";